var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.923,
    height: 140.867,
    viewBox: "0 0 86.923 140.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_238",
    x: 19.961,
    y: 78.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 19.5,
    cy: 20,
    rx: 19.5,
    ry: 20,
    transform: "translate(0.492 -0.007)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11632",
    x: 21.332,
    y: 88.047,
    width: 44.574,
    height: 38.776,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4113",
    "data-name": "Rectangle 4113",
    width: 86.923,
    height: 140.867,
    transform: "translate(0 23)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person_Deleted",
    "data-name": "Person Deleted",
    transform: "translate(-1013.566 -435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11448",
    "data-name": "Group 11448",
    transform: "translate(7197.287 12676.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6183.72, -12241.26)",
    filter: "url(#Ellipse_238)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238-2",
    "data-name": "Ellipse 238",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(21.46 79)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_57",
    "data-name": "Mask Group 57",
    transform: "translate(-6159.751 -12158.252)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livechaticon_Light_theme_",
    "data-name": "Livechaticon(Light theme)",
    transform: "translate(-1.137 5.541)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.83, -88.55)",
    filter: "url(#Path_11632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11632-2",
    "data-name": "Path 11632",
    d: "M755.351,95.037c-4.335-2.055-7.612-1.806-8.447-3.959a5,5,0,0,0-1.188-2.508c-.554-.5-.954-.491-1.32-1.056a3.2,3.2,0,0,1-.264-2.244,13.476,13.476,0,0,1,.792-2.376,16.852,16.852,0,0,1,.792-2.376,17.674,17.674,0,0,1,1.056-1.584c1.069-1.789,1.3-3.962.792-4.223-.18-.092-.349.106-.528,0-.358-.211-.122-1.22.132-2.244.379-1.53.342-3.769-.66-4.751a7.792,7.792,0,0,1-.792-.792,6.654,6.654,0,0,1-.792-1.188c-.847-1.519-4.132-2.376-6.6-2.244a11.446,11.446,0,0,0-1.188.132c-.259.042-.565.1-.9.182a7.84,7.84,0,0,1-2.117-.513c-1.461-.582-2.45-1.5-2.554-1.384s.777,1.006,1.277,2.128a2.609,2.609,0,0,1,.212,1.053,1.558,1.558,0,0,0-.4.376c-.461-.482-1.18-1.81-1.3-1.748-.1.05.388.926.532,2.128a5.824,5.824,0,0,1,.028,1.061,7.875,7.875,0,0,1-.712.807,4.391,4.391,0,0,0-.924,2.244c-.4,2.383,1.348,4.3.726,4.817-.207.171-.394-.045-.66.132-.776.516-.334,3.117,1.056,5.015.258.352.259.285.528.66a9.262,9.262,0,0,1,1.452,3.563c.34,1.623.532,2.544,0,3.168-.406.476-.818.29-1.32.792-.768.768-.454,1.854-.66,2.64-.456,1.741-3.334,2.084-5.675,2.771a22.458,22.458,0,0,0-7.457,3.894l-.264.264h41.574A21.943,21.943,0,0,0,755.351,95.037Z",
    transform: "translate(-695.17 26.65)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11450",
    "data-name": "Group 11450",
    transform: "translate(1013.566 412.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11449",
    "data-name": "Group 11449",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11633",
    "data-name": "Path 11633",
    d: "M106.144,850.986H36.674a7.815,7.815,0,0,0-7.815,7.815l5.21,94.481a7.815,7.815,0,0,0,7.815,7.815h59.049a7.815,7.815,0,0,0,7.815-7.815l5.21-94.481a7.815,7.815,0,0,0-7.815-7.815M50.9,953.586c-.109.008-.217.01-.326.01a5.209,5.209,0,0,1-5.195-4.89l-5.21-84.687a5.21,5.21,0,0,1,10.4-.641l5.21,84.688a5.21,5.21,0,0,1-4.879,5.521m25.715-5.2a5.21,5.21,0,1,1-10.42,0V863.7a5.21,5.21,0,1,1,10.42,0Zm20.817.321a5.209,5.209,0,0,1-5.195,4.89c-.108,0-.216,0-.326-.01a5.21,5.21,0,0,1-4.879-5.521l5.21-84.687a5.21,5.21,0,0,1,10.4.641Z",
    transform: "translate(-27.036 -797.23)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11634",
    "data-name": "Path 11634",
    d: "M9.8,42.481l64.946-29.2A6.945,6.945,0,0,0,69.045.61L4.1,29.812A6.945,6.945,0,1,0,9.8,42.481M22.962,16.706,46.722,6.022a5.848,5.848,0,0,1,5.643.481l3.89-1.749a9.75,9.75,0,0,0-11.136-2.3L21.359,13.142A9.75,9.75,0,0,0,15.686,23l3.89-1.749a5.848,5.848,0,0,1,3.385-4.54",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 17.124, 7.832)",
    fill: "#3b3b3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonDeleted);
export default __webpack_public_path__ + "static/media/Person Deleted.6573d1f06753c43a88c5eb4060a87375.svg";
export { ForwardRef as ReactComponent };